import { dateFormatServer, dpParseDate } from '../filters'

class Person {

  constructor (data) {
    if (data !== undefined) {
      data.nascita_data = dpParseDate(data.nascita_data)
      Object.entries(data).forEach(([key, value]) => {
        this[key] = value
      })
    }
  }

  prepareForSend () {
    let data = _.cloneDeep(this)
    data.nascita_data = dateFormatServer(data.nascita_data)
    return data
  }
}

export {
  Person as default
}



// WEBPACK FOOTER //
// ./src/models/person.js